class HomeController {
  constructor() {
    this.name = 'home';
  }
}

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js